import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0034',
    ecrans: ['00-2']
});
